// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__2gERg","spinner":"page_spinner__R0PuL"};